import axiosInstance from '../../../../config/axiosInstance';
const handleSubmit = async (currencyList) => {
    try {
        const CompanyID = localStorage.getItem("CompanyID");
        const dataPayload = {
            
            ClientID: CompanyID, // If needed, you can also include CompanyID
            currencyList: currencyList // The existing currency data you're already sending
        };
        const response = await axiosInstance.post(`/Setup/CreateMultipleCurrency`, dataPayload);
    } catch (error) {
        console.error('Error posting data:', error);
    }
};

export { handleSubmit };